<template>
  <div id="ClientsList" class="bg-color1" style="height:calc(100vh);">
    <div ref="app_head" class="col-12 fixed-t">
        <div class="col-12 lh40 bg-color-white pl5 pr5 bb1">
          <div class="col-3 f18" @click="$router.back(-1)"><i class="iconfont icon-31fanhui1 color-primary"></i></div>
          <div class="col-6 t-c color-primary"><span class="f24 fw">C</span>lientes</div>
          <div class="col-3 t-r f22 pr3"></div>
        </div>
        <div class="col-12 bg-color-white pl10 pr10 pt5 pb5">
          <div class="col-12">
            <div class="col-12 bg-color1 pt8 pb8 pl10 pr5 r5">
              <div class="col-1">
                <i class="iconfont icon-search color-muted"></i>
              </div>
              <div class="col-10">
                <input type="text" class="w-100 bg-color1" v-model="keyword" @keyup.enter="get_list_data()">
              </div>
              <div class="col-1 t-r">
                <i class="iconfont icon-error color-muted" @click="keyword_reset()" v-if="keyword"></i>
              </div>
            </div>
          </div>
        </div>
    </div>
    <div class="h8"></div>
    <div class="col-12 pt8 pb10 bg-color1" style="overflow-y: auto;">
      <div class="col-12 pl5 pr5 mt5" v-for="(client,client_i) in data_list" v-bind:key="client_i" @click="go_client(client.id)">
        <div class="col-12">
          <div class="col-12 bg-color-white p5">
              <div class="col-2 f40 color-primary t-c">
                <img v-bind:src="client.pic" v-if="client.pic">
                <img src="@/assets/user.png" v-else class="w5 r50">
              </div>
              <div class="col-9 pl10">
                <div class="col-12 f14 uppercase"><span v-if="client.client_code != client.client_lic">{{ client.client_code }} - </span> {{ client.client_lic }}</div>
                <div class="col-12 f14 fw uppercase pb2 el1">{{ client.client_name }}</div>
                <div class="col-12 color-muted f12">{{ client.update_time}}</div>
              </div>
              <div class="col-1 color-muted t-r lh50"><i class="iconfont icon-31fanhui2"></i></div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-12 t-c pt10 pb10">
      <page-component :page-config="pageConfigTotal" @changeCurrentPage="changePage"></page-component>
    </div>
  </div>
</template>
<script>
import pageComponent from "../pageComponent"
export default {
  name: 'ClientsList',
  data () {
    return {
      keyword: '',
      data_list: [],
      data_page: 1,
      pageConfigTotal:{total:0,pageSize:20,pageNo:1},
    }
  },
  created: function () {
    this.keyword = this.$store.state.client_keyword;
    this.get_list_data();
  },
  methods: {
    get_list_data() {
      var keyword = this.keyword;
      if(keyword < 2){
        //return;
      }
      var post_data = {};
      post_data.keyword = keyword;
      post_data.page = this.data_page - 1;
      if(post_data.page < 0){
        post_data.page = 0;
      }
      this.post(this.api_url + 'manage/clients', post_data).then((res)=>{
        if(res.status == 1){
          this.data_list = res.data.clients;
          this.pageConfigTotal.total = res.data['clients_count'];
          //this.$store.commit('setClientKeyword', keyword);
          //this.$store.commit('setBodyH', this);
        }else{
          this.data_list = []
          if(res.status == 2){
            //this.$router.push({name:'Activation',params:{rif: res.data, act_type: 0}});
          }
        }
      })
    },
    keyword_reset(){
      this.keyword = '';
      this.get_list_data();
    },
    changePage(page){
      this.pageConfigTotal.pageNo = page
      this.data_page = page;
      this.get_list_data();
    },
    go_client(id){
      this.$router.push({name:'M_Client',query:{id: id}});
    }
  },
  components:{'page-component':pageComponent}
}
</script>



// WEBPACK FOOTER //
// src/components/Main/ClientsList.vue